import React from 'react';
import AdminSystemLayout from "@containers/adminSystem/layout/AdminSystemLayout";
import {AdminAccountsTableLazy} from "@containers/adminAccounts/table/AdminAccountsTable.lazy";

export const AdminAccountsPage = () => {
	return (
		<AdminSystemLayout>
			<AdminAccountsTableLazy/>
		</AdminSystemLayout>
	)
};

export default AdminAccountsPage;
